import React, { useState } from "react";
import Home from "../home/home";
import WorkExperience from "../work-experience/workExperienceList";
import WorkExperienceMobile from "../work-experience/workExperienceListMobile";
import SideProjects from "../side-projects/sideProjects";
import AboutMe from "../about-me/aboutMe";
import LetsConnect from "../letsConnect/letsConnect";
import data from "../../static-data/static-data.json";
import { Breakpoint } from "react-socks";
import PropTypes from "prop-types";

const PortfolioComponent = (props) => {
  const [staticData] = useState([...data]);
  const workExperience = staticData[0].workExperience;
  const sideProjects = staticData[1].sideProjects;

  return (
    <div
      className={`container scroll-box ${
        !props.sideDrawerOpen ? "bg-blur" : ""
        }`}
    >
      <Home />
      <AboutMe />
      <Breakpoint small down>
        <WorkExperienceMobile workExperience={workExperience} />
      </Breakpoint>

      <Breakpoint medium up>
        <WorkExperience workExperience={workExperience} />
      </Breakpoint>

      <SideProjects sideProjects={sideProjects} />
      <LetsConnect />
    </div>
  );
};

PortfolioComponent.propTypes = {
  sideDrawerOpen: PropTypes.bool.isRequired,
};

export default PortfolioComponent;
